var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcoMail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M25.5984 12.0476V20.6C25.5984 21.3956 25.2824 22.1587 24.7198 22.7213C24.1572 23.2839 23.3941 23.6 22.5984 23.6H9.39844C8.60279 23.6 7.83973 23.2839 7.27712 22.7213C6.71451 22.1587 6.39844 21.3956 6.39844 20.6V12.0476L15.6936 17.5172C15.786 17.5717 15.8912 17.6004 15.9984 17.6004C16.1056 17.6004 16.2109 17.5717 16.3032 17.5172L25.5984 12.0476ZM22.5984 8C23.3366 7.99988 24.0489 8.27193 24.5991 8.76409C25.1493 9.25625 25.4986 9.93397 25.5804 10.6676L15.9984 16.304L6.41644 10.6676C6.49823 9.93397 6.84763 9.25625 7.39779 8.76409C7.94796 8.27193 8.66026 7.99988 9.39844 8H22.5984Z",
    fill: "#0076E4"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoMail);
export default __webpack_public_path__ + "static/media/ico-mail.18cc754a2ee92999fe79d71d128f6a74.svg";
export { ForwardRef as ReactComponent };